export default "__VITE_ASSET__b3dcb555__"